import { Navigate, Route, Routes } from "react-router-dom";
import React from "react";
import MetadataStats from "../metadata/MetadataStats";
import Cursos from "../metadata/cursos/Cursos";
import Empresas from "../metadata/empresas/Empresas";
import Alumnos from "../metadata/alumnos/Alumnos";
import Asignaciones from "../metadata/asignaciones/Asignaciones";

const AppMetadataRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<MetadataStats />} />
            <Route path="/cursos" element={<Cursos />} />
            <Route path="/empresas" element={<Empresas />} />
            <Route path="/alumnos" element={<Alumnos />} />
            <Route path="/asignaciones" element={<Asignaciones />} />
            <Route path="*" element={<Navigate to="/metadata" replace />} />
        </Routes>
    );
};

export default AppMetadataRoutes;
